"use client";

import type { CSSProperties } from "react";
import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      closeButton
      position="top-right"
      theme="system"
      style={{
        "--normal-bg": "var(--popover)",
        "--normal-border": "var(--border)",
        "--normal-text": "var(--popover-foreground)",
        "--success-bg": "color-mix(in srgb, var(--agent-success) 8%, var(--popover))",
        "--success-border": "color-mix(in srgb, var(--agent-success) 32%, var(--border))",
        "--success-text": "var(--popover-foreground)",
        "--warning-bg": "color-mix(in srgb, var(--agent-warning) 9%, var(--popover))",
        "--warning-border": "color-mix(in srgb, var(--agent-warning) 34%, var(--border))",
        "--warning-text": "var(--popover-foreground)",
        "--error-bg": "color-mix(in srgb, var(--destructive) 8%, var(--popover))",
        "--error-border": "color-mix(in srgb, var(--destructive) 34%, var(--border))",
        "--error-text": "var(--popover-foreground)",
      } as CSSProperties}
      toastOptions={{
        classNames: {
          toast:
            "group border-border !bg-popover !text-popover-foreground shadow-sm rounded-lg",
          title: "text-sm font-medium text-foreground",
          description: "text-sm !text-foreground/80",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
          closeButton:
            "!left-[5px] !right-auto !top-[5px] !translate-x-[-50%] !translate-y-[-50%] border-border !bg-popover !text-foreground opacity-100 shadow-sm hover:!bg-accent hover:!text-foreground",
          success:
            "border-l-4 border-l-[var(--agent-success)] border-[color-mix(in_srgb,var(--agent-success)_32%,var(--border))] bg-[color-mix(in_srgb,var(--agent-success)_8%,var(--popover))] text-popover-foreground [&_[data-icon]]:text-[var(--agent-success)]",
          warning:
            "border-l-4 border-l-[var(--agent-warning)] border-[color-mix(in_srgb,var(--agent-warning)_34%,var(--border))] bg-[color-mix(in_srgb,var(--agent-warning)_9%,var(--popover))] text-popover-foreground [&_[data-icon]]:text-[var(--agent-warning)]",
          error:
            "border-l-4 border-l-[var(--destructive)] border-[color-mix(in_srgb,var(--destructive)_34%,var(--border))] bg-[color-mix(in_srgb,var(--destructive)_8%,var(--popover))] text-popover-foreground [&_[data-icon]]:text-[var(--destructive)]",
          info:
            "border-l-4 border-l-[var(--primary)] border-[color-mix(in_srgb,var(--primary)_32%,var(--border))] bg-[color-mix(in_srgb,var(--primary)_8%,var(--popover))] text-popover-foreground [&_[data-icon]]:text-[var(--primary)]",
        },
      }}
    />
  );
}
